"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowButtonTextEditor");
var BonusTournamentSessionsEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentSessionsEditor, _super);
    function BonusTournamentSessionsEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.SID = 0;
        return _this;
    }
    BonusTournamentSessionsEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataPlayersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                players_list: data.data
            }, function () {
                _this.props.dlgSelectPlayer.SetViewData(_this.state.players_list);
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    usr_player_id: _item.usr_player_id,
                    usr_player_login: _item.usr_player_login,
                    tickets_buyed: _item.tickets_buyed,
                    freespins_count_played: _item.freespin_count_played,
                    freespin_win_amount: _item.freespin_win_amount,
                    filterData: ""
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Турниры", "Изменить сессию турнира"]);
                    _this.props.dataPlayersAvail.LoadData(_this.props.rootRecord.brand_id, _this.state.filterData);
                });
            }
        }
        else {
            this.setState({
                usr_player_id: 0,
                usr_player_login: "",
                tickets_buyed: 0,
                freespins_count_played: 0,
                freespin_win_amount: 0,
                filterData: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Турниры", "Добавить сессию турнира"]);
                _this.props.dataPlayersAvail.LoadData(_this.props.rootRecord.brand_id, _this.state.filterData);
            });
        }
        this.doReSetRules();
    };
    BonusTournamentSessionsEditor.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusTournamentSessionsEditor.prototype.doReSetRules = function () {
        this.setState({
            usr_player_rules: { isError: false },
            tickets_buyed_rules: { isError: false },
            freespins_count_played_rules: { isError: false },
            freespin_win_amount_rules: { isError: false }
        });
    };
    BonusTournamentSessionsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.usr_player_id <= 0) || (this.state.usr_player_login.length === 0)) {
            this.setState({ usr_player_rules: { isError: true, errorMessage: "Игрок не выбран!" } });
            return false;
        }
        if (this.props.rootRecord.freespin_count < this.state.freespins_count_played) {
            this.setState({
                freespins_count_played_rules: { isError: true, errorMessage: "Поле [Сыграно фриспинов] больше максимального!" },
            });
            return false;
        }
        if (this.props.rootRecord.freespin_count < 0) {
            this.setState({
                freespins_count_played_rules: { isError: true, errorMessage: "Поле [Сыграно фриспинов] заполнено некорректно!" },
            });
            return false;
        }
        if (!this.props.rootRecord.is_unlimited_buys_count) {
            if (this.props.rootRecord.max_buys_count < this.state.tickets_buyed) {
                this.setState({
                    tickets_buyed_rules: { isError: true, errorMessage: "Поле [Куплено билетов] больше максимального!" },
                });
                return false;
            }
        }
        if (!this.props.rootRecord.is_unlimited_buys_count) {
            if (this.props.rootRecord.max_buys_count < 0) {
                this.setState({
                    tickets_buyed_rules: { isError: true, errorMessage: "Поле [Куплено билетов] заполнено некорректно!" },
                });
                return false;
            }
        }
        return true;
    };
    BonusTournamentSessionsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_id: this.state.usr_player_id,
                bonus_tournament_id: this.props.rootRecord.key,
                tickets_buyed: this.state.tickets_buyed,
                freespin_count_played: this.state.freespins_count_played,
                freespin_win_amount: this.state.freespin_win_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сессия турнира добавлена!");
            });
        }
    };
    BonusTournamentSessionsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                usr_player_id: this.state.usr_player_id,
                tickets_buyed: this.state.tickets_buyed,
                freespin_count_played: this.state.freespins_count_played,
                freespin_win_amount: this.state.freespin_win_amount,
                key: this.props.record.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сессия турнира изменена!");
            });
        }
    };
    BonusTournamentSessionsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentSessionsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить сессию турнира";
        }
        else {
            return "Изменить сессию турнира";
        }
    };
    BonusTournamentSessionsEditor.prototype.doSelectPlayer = function () {
        var _this = this;
        this.props.dlgSelectPlayer
            .SetViewData(this.state.players_list)
            .SetOnSelectClick(function (key, value) {
            _this.setState({
                usr_player_id: key,
                usr_player_login: value,
                usr_player_rules: { isError: false }
            }, function () {
                _this.props.dlgSelectPlayer.Close();
            });
        }).SetOnReLoadData(function (filter) {
            _this.setState({
                filterData: filter
            }, function () {
                _this.props.dlgSelectPlayer.SetFilterVal(_this.state.filterData);
                _this.props.dataPlayersAvail.LoadData(_this.props.rootRecord.brand_id, _this.state.filterData);
            });
        }).SetOnCloseClick(function () {
            _this.props.dlgSelectPlayer.Close();
        })
            .SetTitle("Выберите игрока")
            .SetColumnValueTitle("Логин")
            .Show();
    };
    BonusTournamentSessionsEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentSessionsEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Игрок:", placeholder: "Выберите игрока", buttonHint: "Выберите игрока" }, readonly: true, onButtonClick: this.doSelectPlayer.bind(this), onValueChanged: null, value: this.state.usr_player_login, buttonIcon: "user", rules: this.state.usr_player_rules, required: true, disabled: false }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Куплено билетов:", placeholder: "Введите кол-во купленных билетов" }, values: { max: 999999, min: 1, value: this.state.tickets_buyed }, onValueChanged: function (newVal) {
                    _this.setState({
                        tickets_buyed: newVal,
                        tickets_buyed_rules: { isError: false }
                    });
                }, required: true, rules: this.state.tickets_buyed_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сыграно фриспинов:", placeholder: "Введите кол-во сыгранных фриспинов" }, values: { max: 999999, min: 0, value: this.state.freespins_count_played }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespins_count_played: newVal,
                        freespins_count_played_rules: { isError: false }
                    });
                }, required: true, rules: this.state.freespins_count_played_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Выигрыш в фриспинах:", placeholder: "Введите сумму выигрыша в фриспинах" }, values: { max: 999999, min: 1, value: this.state.freespin_win_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        freespin_win_amount: newVal,
                        freespin_win_amount_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.freespin_win_amount_rules }),
            this.getDownButtons()));
    };
    return BonusTournamentSessionsEditor;
}(React.Component));
exports.default = BonusTournamentSessionsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/sessions/BonusTournamentSessionsEditor.tsx
// module id = 2526
// module chunks = 0